export const emitterEvents = {
  IDENTITY_AUTHORIZE_MODAL_OPEN_EVENT: 'identityAuthorizeModalOpen'
}
